import { Link } from 'react-router-dom';
import * as Lucide from 'lucide-react';
import { ArrowRight } from 'lucide-react';
import Reveal from './Reveal';
import { products } from '../mock';

const Products = () => {
  return (
    <section className="relative py-28 lg:py-36 px-6 lg:px-10">
      <div className="max-w-[1300px] mx-auto">
        <Reveal>
        <div className="text-center mb-16 lg:mb-20">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="h-px w-10 bg-primary" />
            <span className="text-[11px] tracking-[0.28em] text-accent font-medium">
              URUNLERIMIZ
            </span>
            <span className="h-px w-10 bg-primary" />
          </div>
          <h2 className="text-[40px] sm:text-[48px] lg:text-[56px] leading-[1.05] font-semibold text-white max-w-3xl mx-auto">
            Kapsamli Cozum Portfoyu
          </h2>
          <p className="mt-5 text-[15px] text-white/55 max-w-xl mx-auto">
            Her projeye ozel, mukemmellik odakli yapi cozumleri sunuyoruz.
          </p>
          </div>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {products.map((p, i) => {
            const Icon = Lucide[p.icon] || Lucide.Box;
            return (
              <Reveal key={p.slug} delay={i * 60}>
              <Link
                data-testid={`home-product-${p.slug}`}
                to={`/urunler/${p.slug}`}
                className="group text-left relative p-7 rounded-2xl bg-card border border-border hover:border-primary/60 transition-all duration-500 hover:-translate-y-1 hover:shadow-xl hover:shadow-primary/10 overflow-hidden block"
              >
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none">
                  <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-transparent" />
                </div>
                <div className="relative">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl border border-primary/30 bg-primary/10 mb-6 group-hover:bg-primary/15 group-hover:border-primary/60 transition-all duration-500">
                    <Icon size={22} strokeWidth={1.5} className="text-accent" />
                  </div>
                  <h3 className="text-[17px] font-semibold text-white mb-2.5 leading-snug">
                    {p.title}
                  </h3>
                  <p className="text-[13.5px] text-white/55 leading-relaxed">
                    {p.description}
                  </p>
                </div>
              </Link>
              </Reveal>
            );
          })}
        </div>

        <div className="text-center mt-14">
          <Link
            data-testid="home-products-all-link"
            to="/urunler"
            className="inline-flex items-center gap-2 text-[13px] tracking-[0.18em] font-semibold text-accent hover:text-white transition-colors group"
          >
            TUM URUNLERI INCELEYIN
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Products;
